import { CredentialsService } from '../auth/credentials.service';
import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { from, Observable, throwError, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '@env/environment';
import { Logger } from '../logger.service';
import { Router } from '@angular/router';
import { AuthenticationService } from '../auth';
import { ResponseDialogComponent } from '@app/@shared/dialogs/response/response-dialog.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { LoaderGenericService } from '@app/@shared/loader-generic/loader-generic.service';
import { LOGIN } from '../constants/routes.constants';

const log = new Logger('ErrorHandlerInterceptor');

/**
 * Adds a default error handler to all requests.
 */
@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private credentialsService: CredentialsService,
    private authenticationservice: AuthenticationService,
    private dialog: MatDialog,
    private translate: TranslateService,
    private loaderGenericService: LoaderGenericService
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap((evt) => {}),
      catchError((error: any) => {
        if (error instanceof HttpErrorResponse) {
          if (this.credentialsService.isAuthenticated()) {
            if (error.status === 403) {
              //Logout
              this.credentialsService.setCredentials();
              this.authenticationservice.logout();
              this.navigateToLogin();
              //this.router.navigate(['/error/403'], { replaceUrl: true });
            } else if (request.responseType === 'blob' && error.error instanceof Blob) {
              return from(
                Promise.resolve(error).then(async (x) => {
                  throw new HttpErrorResponse({
                    error: JSON.parse(await x.error.text()),
                    headers: x.headers,
                    status: x.status,
                    statusText: x.statusText,
                    url: x.url ?? undefined,
                  });
                })
              );
            } else if (error.url?.includes(environment.subUrlObtenerTokenVideoselfing)) {
              this.showErrorDialog(this.translate.instant('videoselfing.error.maxTry'), true);
            } else {
              this.loaderGenericService.stopSpinner();
              throw error;
            }
          } else {
            if (error.url?.includes(environment.subUrlObtenerTokenVideoselfing)) {
              this.showErrorDialog(this.translate.instant('videoselfing.error.maxTry'), true);
            }
            if (error.url?.includes(environment.subUrlStartAsyncSignature)) {
              throw error;
            }
            if (error.url?.includes(environment.subUrlRecovery)) {
              throw error;
            }

            if (error.error?.message?.includes('permanent block')) {
              this.showErrorDialog(this.translate.instant('dialog.block.permanent'));
            } else if (error.error?.message?.includes('temporary block')) {
              this.showErrorDialog(this.translate.instant('dialog.block.temporary'));
            }
          }
        }
        return of(error);
      })
    );
  }

  private showErrorDialog(message: string, noNavigate?: boolean) {
    let dialogConfig = new MatDialogConfig();
    dialogConfig.width = '90%';
    dialogConfig.maxWidth = '450px';
    dialogConfig.data = {
      text: message,
      icon: 'icon-ic_warning',
      noRedirect: true,
    };
    this.dialog.open(ResponseDialogComponent, dialogConfig);
    if (!noNavigate) {
      this.navigateToLogin();
    }
  }

  private navigateToLogin() {
    this.router.navigate([LOGIN], { replaceUrl: true });
    this.loaderGenericService.stopSpinner();
  }
}
